import 'css-chunkapp/javascript/influencer/pages/offer/components/ObjectAttributesBox/ObjectAttributesBox.module.scss';export default {
  "bg-black": "ObjectAttributesBox-module__bg-black___7QAcA",
  "tc-black": "ObjectAttributesBox-module__tc-black___-tA3S",
  "bg-white": "ObjectAttributesBox-module__bg-white___3ZA5I",
  "tc-white": "ObjectAttributesBox-module__tc-white___z80rm",
  "bg-blue": "ObjectAttributesBox-module__bg-blue___GohV1",
  "tc-blue": "ObjectAttributesBox-module__tc-blue___EZxVs",
  "bg-grey1": "ObjectAttributesBox-module__bg-grey1___YtFsH",
  "tc-grey1": "ObjectAttributesBox-module__tc-grey1___5IYTx",
  "bg-grey2": "ObjectAttributesBox-module__bg-grey2___D-XHl",
  "tc-grey2": "ObjectAttributesBox-module__tc-grey2___YFLZT",
  "bg-grey3": "ObjectAttributesBox-module__bg-grey3___pu4-8",
  "tc-grey3": "ObjectAttributesBox-module__tc-grey3___48Dct",
  "bg-grey4": "ObjectAttributesBox-module__bg-grey4___EyeYc",
  "tc-grey4": "ObjectAttributesBox-module__tc-grey4___Wmyxa",
  "bg-orange": "ObjectAttributesBox-module__bg-orange___P5QGI",
  "tc-orange": "ObjectAttributesBox-module__tc-orange___iCGMy",
  "bg-pink": "ObjectAttributesBox-module__bg-pink___GXlgF",
  "tc-pink": "ObjectAttributesBox-module__tc-pink___Y0-XO",
  "bg-purple": "ObjectAttributesBox-module__bg-purple___WjPmv",
  "tc-purple": "ObjectAttributesBox-module__tc-purple___9FQzs",
  "bg-green": "ObjectAttributesBox-module__bg-green___VPODE",
  "tc-green": "ObjectAttributesBox-module__tc-green___uSPUI",
  "bg-green-2": "ObjectAttributesBox-module__bg-green-2___vCnHr",
  "tc-green-2": "ObjectAttributesBox-module__tc-green-2___7ima-",
  "bg-red": "ObjectAttributesBox-module__bg-red___x4aCA",
  "tc-red": "ObjectAttributesBox-module__tc-red___gWHO0",
  "bg-red-2": "ObjectAttributesBox-module__bg-red-2___isxF5",
  "tc-red-2": "ObjectAttributesBox-module__tc-red-2___aaSHT",
  "bg-yellow": "ObjectAttributesBox-module__bg-yellow___Sj1ve",
  "tc-yellow": "ObjectAttributesBox-module__tc-yellow___Jduzv",
  "bg-yellow-2": "ObjectAttributesBox-module__bg-yellow-2___zzj4S",
  "tc-yellow-2": "ObjectAttributesBox-module__tc-yellow-2___07-zd",
  "bg-blue-4": "ObjectAttributesBox-module__bg-blue-4___8RWh2",
  "tc-blue-4": "ObjectAttributesBox-module__tc-blue-4___DO4-9",
  "bg-blue-5": "ObjectAttributesBox-module__bg-blue-5___9EpFq",
  "tc-blue-5": "ObjectAttributesBox-module__tc-blue-5___54VYi",
  "bg-blue-6": "ObjectAttributesBox-module__bg-blue-6___uZLTE",
  "tc-blue-6": "ObjectAttributesBox-module__tc-blue-6___KhD3m",
  "ObjectAttributesBox": "ObjectAttributesBox-module__ObjectAttributesBox___-ecp6",
  "wrapper": "ObjectAttributesBox-module__wrapper___xRVJs"
};